module.exports = __webpack_public_path__ + "img/pro-p-slider8.c18aa8ae.png";